import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

import { theme } from '../../theme';

export interface SettingsIconProps {
  color?: string;
}

export const SettingsIcon = ({
  color = theme.palette.primary.main,
}: SettingsIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 18.176 18.176">
      <path
        d="M19.365,13.372a5.683,5.683,0,0,0,.046-.909c0-.318-.046-.591-.046-.909l1.952-1.5a.417.417,0,0,0,.093-.591L19.55,6.329a.453.453,0,0,0-.558-.182l-2.324.909a6.765,6.765,0,0,0-1.58-.909l-.325-2.408a.5.5,0,0,0-.465-.363H10.581a.5.5,0,0,0-.465.363L9.744,6.147a7.87,7.87,0,0,0-1.58.909L5.84,6.147a.435.435,0,0,0-.558.182L3.423,9.464a.549.549,0,0,0,.093.591l2,1.5c0,.318-.046.591-.046.909s.046.591.046.909l-1.952,1.5a.417.417,0,0,0-.093.591L5.329,18.6a.453.453,0,0,0,.558.182l2.324-.909a6.764,6.764,0,0,0,1.58.909l.372,2.408a.45.45,0,0,0,.465.363h3.718a.5.5,0,0,0,.465-.363l.372-2.408a7.866,7.866,0,0,0,1.58-.909l2.324.909a.435.435,0,0,0,.558-.182L21.5,15.462a.548.548,0,0,0-.093-.591ZM12.44,15.644a3.182,3.182,0,1,1,3.253-3.181A3.2,3.2,0,0,1,12.44,15.644Z"
        transform="translate(-3.375 -3.375)"
        fill={color}
      />
    </SvgIcon>
  );
};
